module.exports = __webpack_public_path__ + "media/honey-icons/icon-star-half-11fecfe2.svg";